import { MoneyAmount } from '../value-objects/MoneyAmount';
import { YearResult } from '../entities/YearResult';

export interface TimingPolicy {
  applyStartOfYearCashflows(args: {
    portfolioStart: MoneyAmount;
    withdrawal: MoneyAmount;
    income: MoneyAmount;
    extraExpense: MoneyAmount;
  }): MoneyAmount;

  applyEndOfYearGrowth(args: {
    portfolioPostWithdrawal: MoneyAmount;
    annualReturn: number;
  }): MoneyAmount;

  runYear(args: {
    yearIndex: number;
    portfolioStart: MoneyAmount;
    withdrawal: MoneyAmount;
    income: MoneyAmount;
    extraExpense: MoneyAmount;
    annualReturn: number;
  }): YearResult;
}

export class BeginningOfYearPolicy implements TimingPolicy {
  applyStartOfYearCashflows({
    portfolioStart,
    withdrawal,
    income,
    extraExpense,
  }: {
    portfolioStart: MoneyAmount;
    withdrawal: MoneyAmount;
    income: MoneyAmount;
    extraExpense: MoneyAmount;
  }): MoneyAmount {
    return portfolioStart
      .subtract(withdrawal)
      .subtract(extraExpense)
      .add(income);
  }

  applyEndOfYearGrowth({
    portfolioPostWithdrawal,
    annualReturn,
  }: {
    portfolioPostWithdrawal: MoneyAmount;
    annualReturn: number;
  }): MoneyAmount {
    return portfolioPostWithdrawal.multiply(1 + annualReturn);
  }

  runYear({
    yearIndex,
    portfolioStart,
    withdrawal,
    income,
    extraExpense,
    annualReturn,
  }: {
    yearIndex: number;
    portfolioStart: MoneyAmount;
    withdrawal: MoneyAmount;
    income: MoneyAmount;
    extraExpense: MoneyAmount;
    annualReturn: number;
  }): YearResult {
    const portfolioPostWithdrawal = this.applyStartOfYearCashflows({
      portfolioStart,
      withdrawal,
      income,
      extraExpense,
    });
    const portfolioEnd = this.applyEndOfYearGrowth({
      portfolioPostWithdrawal,
      annualReturn,
    });
    return new YearResult({
      yearIndex,
      portfolioStart: portfolioStart.value,
      withdrawal: withdrawal.value,
      income: income.value,
      extraExpense: extraExpense.value,
      portfolioEnd: portfolioEnd.value,
      success: portfolioEnd.value >= 0,
    });
  }
}